export const loadScript = (url: string, scriptId?: string, tags?: object): Promise<void> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        if (scriptId) {
            script.id = scriptId;
        }

        if (tags) {
            Object.keys(tags).forEach((key, _) => {
                script.setAttribute(key, tags[key]);
            });
        }

        script.addEventListener('load', () => {
            resolve();
        });

        script.addEventListener('error', () => {
            reject();
        });

        document.head.appendChild(script);
    });
};
